import React from 'react';

import { AppValue } from './types';

const AppContext = React.createContext<AppValue>({
  appTitle: null,
  geoId: null,
  geoIds: null,
  radius: 10,
  reportData: null,
  riskDriverLimit: 3,
  userId: -1,
  zipCode: null,
  primaryBrand: {
    id: -1,
    name: '',
    placement: 'primary',
  },
  secondaryBrand: null,
  tertiaryBrand: null,
  setAppTitle: null,
  setGeoIds: null,
  setGeoId: null,
  setOrganizationBrand: null,
  setOrganizationName: null,
  setRadius: null,
  setReportData: null,
  setRiskDriverLimit: null,
  setUserId: null,
  setZipCode: null,
});

export default AppContext;
